import { ChangeDetectionStrategy, Component } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { UserStateService } from '@frontend/sports/user/feature';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';

import { IBetslipRootState } from '../../../../base/store/state';
import { BetslipPick } from '../../../../core/picks/betslip-pick';
import { PickOddsState } from '../../../../core/picks/pick-models';
import { editBetStateSelector } from '../../../types/selectors';
import { IEditMyBetState } from '../../state';

@Component({
    selector: 'bs-edit-bet-add-pick-container',
    templateUrl: './edit-bet-add-pick-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export default class EditBetAddPickContainerComponent {
    editBetState$: Observable<IEditMyBetState>;
    oddsDisplayFormat$: Observable<OddsDisplayFormat>;

    constructor(userState: UserStateService, store: Store<IBetslipRootState>) {
        this.editBetState$ = store.select(editBetStateSelector);

        this.oddsDisplayFormat$ = userState.userState$().pipe(map((state) => state.oddsFormat || OddsDisplayFormat.EU));
    }

    pickTrackBy(_: number, pick: BetslipPick): string {
        return pick.id.toString();
    }

    getPickStateClass(pick: BetslipPick): string {
        switch (pick.oddsState) {
            case PickOddsState.Open:
                return 'betslip-pick__status-open';
            case PickOddsState.Locked:
                return 'betslip-pick__status-locked';
            case PickOddsState.Closed:
                return 'betslip-pick__status-closed';
        }
    }
}
